/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanChangeFixedCostNumberRequestDto
 */
export interface MonthPlanChangeFixedCostNumberRequestDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanChangeFixedCostNumberRequestDto
   */
  fundId: string;
  /**
   *
   * @type {number}
   * @memberof MonthPlanChangeFixedCostNumberRequestDto
   */
  number: number;
}

export function MonthPlanChangeFixedCostNumberRequestDtoFromJSON(json: any): MonthPlanChangeFixedCostNumberRequestDto {
  return MonthPlanChangeFixedCostNumberRequestDtoFromJSONTyped(json, false);
}

export function MonthPlanChangeFixedCostNumberRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanChangeFixedCostNumberRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fundId: json["fundId"],
    number: json["number"],
  };
}

export function MonthPlanChangeFixedCostNumberRequestDtoToJSON(
  value?: MonthPlanChangeFixedCostNumberRequestDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fundId: value.fundId,
    number: value.number,
  };
}
